var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"countdown"},[_c('h1',{staticClass:"font-weight-thin d-flex justify-center",attrs:{"id":"countdown"}})])}
var staticRenderFns = []

export { render, staticRenderFns }